import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const LazyLoadSlick = dynamic(() => import("../CarouselMuiSlider"), { ssr: false });

const SliderContainer = (props) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return <p>Loading slider...</p>; // Placeholder while loading on client
  }

  return <LazyLoadSlick {...props}/>;
};

export default SliderContainer;
